import React from 'react';

const Footer = () => {
	return (
		<div>
			<footer>
				<p>All Rights Reserved. Copyright © 2022</p>
			</footer>
		</div>
	);
};

export default Footer;
